import React from 'react';
import ReactModal from 'react-modal';
import styles from './Dialog.module.scss';
import cn from 'classnames';
import { Icon } from 'src/components/common/Icon/Icon';
import { Heading } from 'src/components/common/Heading/Heading';

interface DialogProps {
  isOpen: boolean;
  onClose: () => void;
  options?: Partial<ReactModal['props']>;
  title: string;
  subtitle?: string;
  padding?: boolean;
}

export const Dialog: React.FC<DialogProps> = (props) => {
  const { children, padding = true, isOpen, onClose, options, title, subtitle } = props;
  return (
    <ReactModal
      isOpen={isOpen}
      overlayClassName={styles['o-dialog']}
      className={styles['o-dialog__aligner']}
      onRequestClose={onClose}
      shouldCloseOnEsc
      shouldFocusAfterRender
      shouldCloseOnOverlayClick
      shouldReturnFocusAfterClose
      {...options}
    >
      <div className={cn(styles['o-dialog__content'], { [styles['o-dialog__content--padding']]: padding })}>
        <button onClick={onClose} type="button" className={styles['o-dialog__close']} aria-label="Close dialog">
          <Icon name="XIcon" />
        </button>
        <Heading size="h1" className={styles['o-dialog__title']}>{title}</Heading>
        {subtitle && <Heading size="h3" className={styles['o-dialog__subtitle']}>{subtitle}</Heading>}
        {children}
      </div>
    </ReactModal>
  );
};
